import { unzipSync, strFromU8 } from 'fflate';
function xml(text:string) {const doc=new DOMParser().parseFromString(text,'application/xml');if(doc.getElementsByTagName('parsererror').length)throw new Error('Hibás Excel XML-fájl.');return doc}
function textOf(element:Element) {return Array.from(element.getElementsByTagName('t')).map(n=>n.textContent||'').join('')}
function indexOf(reference:string) {let n=0;for(const c of reference.match(/^[A-Z]+/i)?.[0]?.toUpperCase()||'A')n=n*26+c.charCodeAt(0)-64;return n-1}
function dateFromSerial(value:string) {
 const serial=Number(value);if(!Number.isFinite(serial))return value;
 // Excel 1900-as dátumrendszer, a hibás 1900. február 29. figyelembevételével.
 const day=serial>=60?Math.floor(serial)-1:Math.floor(serial);
 return new Date(Date.UTC(1899,11,31)+day*86400000).toISOString().slice(0,10);
}
export function parseXLSX(buffer:ArrayBuffer):string[][] {
 const bytes=new Uint8Array(buffer);
 if(bytes.length>5*1024*1024)throw new Error('Az Excel-fájl legfeljebb 5 MB lehet.');
 let total=0;
 const files=unzipSync(bytes,{filter:file=>{
  const needed=/^(xl\/(workbook\.xml|_rels\/workbook\.xml\.rels|sharedStrings\.xml|worksheets\/[^/]+\.xml))$/.test(file.name);
  if(needed){total+=file.originalSize;if(total>12*1024*1024||file.originalSize>8*1024*1024)throw new Error('Az Excel-fájl kicsomagolt tartalma túl nagy.');}
  return needed;
 }});
 const read=(name:string)=>files[name]?xml(strFromU8(files[name])):null;
 const workbook=read('xl/workbook.xml'), relations=read('xl/_rels/workbook.xml.rels');
 if(!workbook||!relations)throw new Error('Ez nem támogatott XLSX-fájl.');
 if(['1','true'].includes(workbook.getElementsByTagName('workbookPr')[0]?.getAttribute('date1904')||''))throw new Error('1904-es Excel-dátumrendszer: mentsd a táblázatot CSV-formátumban.');
 const sheet=workbook.getElementsByTagName('sheet')[0];
 const relationID=sheet?.getAttribute('r:id');
 const target=Array.from(relations.getElementsByTagName('Relationship')).find(r=>r.getAttribute('Id')===relationID)?.getAttribute('Target');
 if(!target||target.includes('..'))throw new Error('A munkalap nem található.');
 const path=target.startsWith('/')?target.slice(1):'xl/'+target;
 const doc=read(path);if(!doc)throw new Error('Az első munkalap nem olvasható.');
 const strings=Array.from(read('xl/sharedStrings.xml')?.getElementsByTagName('si')||[]).map(textOf);
 const rows=Array.from(doc.getElementsByTagName('row'));
 if(rows.length>501)throw new Error('Egyszerre legfeljebb 500 felmérés importálható.');
 const result=rows.map(row=>{
  const values:string[]=[];
  for(const cell of Array.from(row.getElementsByTagName('c'))){
   const index=indexOf(cell.getAttribute('r')||'A1');if(index>60)throw new Error('Túl sok oszlop az Excel-fájlban.');
   if(cell.getElementsByTagName('f').length)throw new Error('A felmérési táblázat értékeket tartalmazzon; képleteket előbb alakíts át értékké.');
   const type=cell.getAttribute('t'),raw=cell.getElementsByTagName('v')[0]?.textContent||'';
   values[index]=type==='s'?(strings[Number(raw)]||''):type==='inlineStr'?textOf(cell):type==='d'&&/^\d{4}-\d{2}-\d{2}T/.test(raw)?raw.slice(0,10):raw;
  }
  return values;
 }).filter(row=>row.some(v=>v?.trim()));
 const dateColumn=result[0]?.findIndex(s=>s?.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'')==='datum')??-1;
 if(dateColumn>=0)for(const row of result.slice(1)){const value=row[dateColumn]||'';if(/^\d+(\.\d+)?$/.test(value))row[dateColumn]=dateFromSerial(value)}
 return result;
}
